<template>
    <div class="pt-dropdown-select">
        <ElDropdown trigger="click" placement="bottom-start" @command="handleCommand"
                    @visible-change="val => isShowDropdownMenu = val">
            <div class="pt-dropdown-select__trigger" :style="{ 'width': width }">
                <span class="pt-dropdown-select__trigger-text">{{ currentDisplayValue }}</span>
                <PtIcon :icon="isShowDropdownMenu ? 'SolidDropdownClose' : 'SolidDropdownOpen'"
                        class="pt-dropdown-select__trigger-icon"/>
            </div>
            <ElDropdownMenu slot="dropdown" class="pt-data-coverage-dropdown-select__menu" :style="{ 'width': width }">
                <ElDropdownItem
                    v-for="item in config"
                    :key="item.value"
                    :disabled="item.disabled"
                    :command="item.value"
                    :class="{ 'pt-dropdown-select__item': true, 'pt-dropdown-select__item--selected': item.value === value }">
                    <span class="pt-dropdown-select__item-text">{{ item.label }}</span>
                    <PtIcon v-if="item.value === value" icon="SolidTick" class="pt-dropdown-select__item-icon"/>
                </ElDropdownItem>
            </ElDropdownMenu>
        </ElDropdown>
    </div>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/tick.svg';
import '@patsnap-ui/icon/assets/solid/DropdownClose.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
import { get } from 'lodash';

export default {
    name: 'DropdownSelect',
    components: {
        ElDropdown: Dropdown,
        ElDropdownMenu: DropdownMenu,
        ElDropdownItem: DropdownItem,
        PtIcon
    },
    props: {
        value: {
            type: [String, Number],
            required: true
        },
        config: {
            type: Array,
            required: true,
            default: () => []
        },
        width: {
            type: String,
            default: 'auto'
        }
    },
    computed: {
        currentDisplayValue() {
            const select = this.config.find(item => item.value === this.value);
            return get(select, 'label', '');
        }
    },
    data() {
        return {
            isShowDropdownMenu: false
        };
    },
    methods: {
        handleCommand(command) {
            this.$emit('input', command);
            this.$emit('item-click', command);
        }
    }
};
</script>

<style lang="scss">
.pt-dropdown-select {
    vertical-align: middle;
    display: inline-block;

    .pt-dropdown-select__trigger {
        border-radius: 4px;
        border: 1px solid #B3BAC5;
        background-color: $bg-white;
        font-weight: 400;
        color: $text-primary;
        font-size: 14px;
        line-height: 24px;
        padding: 3px 4px 3px 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .pt-dropdown-select__trigger-text {
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .pt-dropdown-select__trigger-icon {
            margin-left: 12px;
            font-size: 24px;
            fill: $fill-normal;
            flex-shrink: 0;
        }
    }
}

.pt-data-coverage-dropdown-select__menu {
    padding: 4px !important;

    &[x-placement^=bottom] {
        margin-top: 4px;
    }

    &[x-placement^=top] {
        margin-bottom: 4px;
    }
}

.pt-data-coverage-dropdown-select__menu {
    .pt-dropdown-select__item {
        font-weight: 400;
        padding-right: 44px !important;
        position: relative;
        color: $text-primary;

        &:hover {
            background-color: rgba(#B3BAC5, 0.2);
            border-radius: 4px;
            color: $text-primary;
        }

        .pt-dropdown-select__item-text {
            display: block;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .pt-dropdown-select__item-icon {
            position: absolute;
            font-size: 24px;
            top: 50%;
            right: 8px;
            fill: #33b900;
            transform: translateY(-50%);
            -ms-transform: translateY(-50%);
        }

        &--selected .pt-dropdown-select__item-text {
            color: #33b900 !important;
        }
    }

    .popper__arrow {
        display: none;
    }
}
</style>
